import React from "react";
import { SwitchComponent } from "../../../../../../../Components";
import { LeadsClassTypesEnum } from "../../../../../../../Enums";

export const PSIClubReferralsTableHeaderData = (
  parentTranslationPath,
  translationPath
) => [
  {
    id: 1,
    key: "leadId",
    label: "lead-no",
    input: "leadId",
    component: (item) =>
      item.leadId ? (
        <a
          className="c-primary newTabActivites"
          onClick={() => {
            const leadClass =
              item.leadType === "Seeker" || item.leadType === "seeker" ? 2 : 1;
            window.open(
              `/home/leads/lead-profile-edit?formType=${leadClass}&id=${item.leadId}`,
              "_blank"
            );
          }}
        >
          {item.leadId || ""}
        </a>
      ) : (
        <span> {item.leadId || ""} </span>
      ),
  },
  {
    id: 2,
    key: "firstName",
    label: "name",
    component: (item) =>
      !item.firstName ? (
        <span></span>
      ) : (
        <span>
          {`${(item?.firstName || "")} ${
            (item?.lastName || "")
          } `}
        </span>
      ),
  },
  {
    id: 3,
    label: "matches",
    key: "matchUnit",
    label: "matches",
    input: "matchUnit",
    component: (item) => (
      <span className="c-primary">{`${item.matchUnit || 0} Matches`}</span>
    ),
  },
  {
    id: 4,
    key: "noActivities",
    label: "activities",
    input: "noActivities",
    label: "activities",
    component: (item) => (
      <span className="c-primary">{`${
        item.noActivities || 0
      } Activities`}</span>
    ),
  },
  {
    id: 5,
    key: "lead-type",
    label: "lead-type",
    input: "lead-type",
    component: (item) =>
      (item.leadClass && (
        <span>
          {
            Object.values(LeadsClassTypesEnum).find(
              (l) => l.key === Number(item.leadClass)
            ).name
          }
        </span>
      )) || <span />,
  },
  {
    id: 6,
    key: "unitType",
    label: "unit-type",
    input: "unitType",
      component: (item) => (
      <span className="">{`${item?.unitType || ""}`}</span>
    ),
  },
  {
    id: 7,
    label: "status",
    key: "status",
    input: "status",
    component: (item, index) => (
      <SwitchComponent
        idRef={`switchRef${index + 1}`}
        isChecked={item.status === "Open" || item.status === "open"}
        labelClasses="px-0"
        themeClass="theme-line"
        labelValue={
          item?.status === "Open" || item?.status === "open" ? "open" : "closed"
        }
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
      />
    ),
  },
  {
    id: 8,
    key: "date",
    label: "date",
    input: "leadCreatedOn",
    isDate: true,
    dateFormat: "DD MMM YYYY hh:mm A",
  },
  {
    id: 9,
    key: "date",
    label: "activity-date",
    input: "activityDate",
    isDate: true,
    dateFormat: "DD MMM YYYY hh:mm A",
  },
  {
    id: 10,
    key: "agentName",
    label: "assigned-to",
    input: "agentName",
     component: (item) => (
      <span className="">{`${item?.agentName || ""}`}</span>
    ),
  },
  {
    id: 11,
    key: "agentAssignedBy",
    label: "agent-assigned-by",
    input: "agentAssignedBy",
    label: "agent-assigned-by",
    component: (item) => (
      <span className="">{`${item?.agentAssignedBy || ""}`}</span>
    ),
  },
];
